export default __webpack_public_path__ + "static/media/deso-logo.dca547d1.png";